
import clsx from "clsx";

const CTSwitch = ({
  checked = false,
  onChange,
  disabled = false,
  label = "",
  size = "md", // sm, md, lg
}) => {
  const sizes = {
    sm: {
      track: "w-8 h-4",
      thumb: "w-3 h-3 translate-x-1",
      thumbChecked: "translate-x-4",
    },
    md: {
      track: "w-11 h-6",
      thumb: "w-5 h-5 translate-x-1",
      thumbChecked: "translate-x-6",
    },
    lg: {
      track: "w-14 h-7",
      thumb: "w-6 h-6 translate-x-1",
      thumbChecked: "translate-x-7",
    },
  };

  const s = sizes[size] || sizes.md;

  return (
    <label
      className={clsx(
        "inline-flex items-center cursor-pointer gap-2",
        disabled && "opacity-50 cursor-not-allowed"
      )}
    >
      {/* Switch */}
      <div
        onClick={() => !disabled && onChange?.(!checked)}
        className={clsx(
          "relative flex items-center rounded-full transition-colors duration-300",
          s.track,
          checked
            ? "bg-orange-500 dark:bg-orange-400"
            : "bg-gray-300 dark:bg-gray-600"
        )}
      >
        <span
          className={clsx(
            "absolute bg-white dark:bg-gray-100 rounded-full shadow-md transform transition-transform duration-300",
            s.thumb,
            checked && s.thumbChecked
          )}
        />
      </div>

      {/* Etiqueta opcional */}
      {label && (
        <span className="text-sm select-none text-gray-800 dark:text-gray-200">
          {label}
        </span>
      )}
    </label>
  );
};

export default CTSwitch;
